import {
  Badge,
  Button,
  Descriptions,
  List,
  Typography,
  theme,
  Spin,
} from "antd";
import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import {
  selectCurrentBusiness,
  selectCurrentBusinessFiles,
} from "../../../businessesSlice";
import { DownloadOutlined, FileOutlined } from "@ant-design/icons";
import {
  canOpenBusinessFile,
  openBusinessFile,
} from "../../Business-Files-Modal/businessFiles.helpers";
import { useBusinessFilesRefresh } from "../../Business-Files-Modal/useBusinessFilesRefresh";
import Loader from "../../../../common/loader/Loader";

const BusinessFiles: React.FC<{ active: boolean }> = ({ active }) => {
  const { token } = theme.useToken();
  const business = useAppSelector(selectCurrentBusiness);
  const businessFiles = useAppSelector(selectCurrentBusinessFiles);
  const isLoadingBusinessFiles = false; // TODO: Add loading state to slice
  useBusinessFilesRefresh(active);

  if (isLoadingBusinessFiles) {
    return <Loader text="Fetching Business Files" />;
  }

  return (
    <div style={{ padding: token.padding }}>
      <List
        itemLayout="horizontal"
        dataSource={businessFiles || []}
        renderItem={(file) => (
          <List.Item
            actions={[
              <Button
                key="download"
                type="link"
                icon={<DownloadOutlined />}
                onClick={() => openBusinessFile(file)}
                disabled={!file.fileName || !canOpenBusinessFile(file)}
              >
                Download
              </Button>,
            ]}
          >
            <List.Item.Meta
              avatar={<FileOutlined />}
              title={file.fileName || <Badge count="Missing" />}
              description={
                <Typography.Text type="secondary">
                  Type: {file.fileExtension || "Unknown"}
                </Typography.Text>
              }
            />
          </List.Item>
        )}
        locale={{
          emptyText: (
            <Typography.Text type="secondary">
              No files uploaded yet
            </Typography.Text>
          ),
        }}
      />
    </div>
  );
};

export default BusinessFiles;
